import { useCallback, memo } from 'react';
import { MainReportGridData } from '@pages/reporting-pages/deliveries-main/types/MainReportGridData';
import { renderKilogramsToTonnes, numberWithSpaces } from 'components/global/utils';
import { BarColor } from 'components/cell-percent-bar/BarColor';
import CellPercentBar from 'components/cell-percent-bar/CellPercentBar';



interface GridRowProps {
	item: MainReportGridData,
	rowIndex: number,
}
  

const GridRow = (props: GridRowProps) => {
	const { rowIndex } = props;
	const { executionPlaceName, country,
		sd_volume, sd_volumePct, sd_weight, sd_returnsWeight, sd_ordersCount,
		int_volume, int_volumePct, int_weight, int_returnsWeight, int_ordersCount,
		dd_volume, dd_volumePct, dd_weight, dd_returnsWeight, dd_ordersCount,
		td_volume, td_volumePct, td_weight, td_returnsWeight, td_ordersCount } = props.item;

	const getClassName = useCallback((centered: boolean, leftAlign: boolean = false) => 
		`app-grid-cell${
			rowIndex % 2 == 0 ? ' secondary-cell' : ' primary-cell'
		}${
			leftAlign ? ' left-align-cell' : ''
		}${
			centered ? ' centered-cell' : ''
		}`
	,[ rowIndex ]);


	return (
		<>
			<div className={getClassName(false, true)}>
				<p>{country}</p>
			</div>

			<div className={getClassName(false, true)}>
				<p>{executionPlaceName}</p>
			</div>


			<CellPercentBar
				cellClassName={getClassName(false)}
				value={sd_volume}
				percentValue={sd_volumePct}
				color={BarColor.blue} />

			<div className={getClassName(false)}>
				<p>{renderKilogramsToTonnes(sd_weight)}</p>
			</div>

			<div className={getClassName(false)}>
				<p>{renderKilogramsToTonnes(sd_returnsWeight)}</p>
			</div>

			<div className={getClassName(false)}>
				<p>{numberWithSpaces(sd_ordersCount)}</p>
			</div>


			<CellPercentBar
				cellClassName={getClassName(false)}
				value={int_volume}
				percentValue={int_volumePct}
				color={BarColor.yellow} />

			<div className={getClassName(false)}>
				<p>{renderKilogramsToTonnes(int_weight)}</p>
			</div>

			<div className={getClassName(false)}>
				<p>{renderKilogramsToTonnes(int_returnsWeight)}</p>
			</div>

			<div className={getClassName(false)}>
				<p>{numberWithSpaces(int_ordersCount)}</p>
			</div>


			<CellPercentBar
				cellClassName={getClassName(false)}
				value={dd_volume}
				percentValue={dd_volumePct}
				color={BarColor.yellow} />

			<div className={getClassName(false)}>
				<p>{renderKilogramsToTonnes(dd_weight)}</p>
			</div>

			<div className={getClassName(false)}>
				<p>{renderKilogramsToTonnes(dd_returnsWeight)}</p>
			</div>

			<div className={getClassName(false)}>
				<p>{numberWithSpaces(dd_ordersCount)}</p>
			</div>


			<CellPercentBar
				cellClassName={getClassName(false)}
				value={td_volume}
				percentValue={td_volumePct}
				color={BarColor.green} />

			<div className={getClassName(false)}>
				<p>{renderKilogramsToTonnes(td_weight)}</p>
			</div>

			<div className={getClassName(false)}>
				<p>{renderKilogramsToTonnes(td_returnsWeight)}</p>
			</div>

			<div className={getClassName(false)}>
				<p>{numberWithSpaces(td_ordersCount)}</p>
			</div>
		</>
	)
}

export default memo(GridRow);